import GoponRes, {Pagable} from '../gopon-res.model';
import { Branch } from "@core/models";

export interface Category {
  Id: number;
  Name: string;
  Image: string;
  Categories:Category[];
}
export interface CatalogRes extends GoponRes {
  Categories: Category[];
}

export class CatalogReq extends Pagable {
  branchId: number = 0;
}

export class ItemsReq extends CatalogReq {
  searchKeyword: string = '';
  categoryId: number = 0;
  isRecommended: boolean = false;
  isNew: boolean = false;
  isSortedByPriceHighToLow: boolean = false;
  isSortedByPriceLowToHigh: boolean = false;
  isMostLiked: boolean = false;
  isMostSelling: boolean = false;
  minPrice: number = 0;
  maxPrice: number = 0;
}
export interface ItemNew {
  ShortDescription: any;
  BranchId: number;
  Id: number;
  Name: string;
  AvailableOnlyOnApp: boolean;
  IsWishListed: boolean;
  IsInStock:boolean;
  IsInStockTitle :string;
  IsHaveAttributes: boolean;
  OfferExpireOn: string;
  OfferExpireOnDateTo: string;
  PriceBundle: PriceBundle | null;
  Logo: string;
  BranchName: string;
  ShareLink: string;
  IsNewItem: boolean;
  CategoryName: string;
  CategoryId: number;
}
export interface BannerNew {
  Id: number;
  Name: string;
  Image: string;
  Type: number;
  RefId: string;
}
export interface ItemDetails {
  YoutubeURL: any;
  Id: number;
  SKU: string | null;
  Name: string;
  ShortDescription: string;
  Logo: string;
  Quantity: number;
  IsRecommended: boolean;
  SpecificQuantity: boolean;
  Price: number;
  PriceDiscount: number;
  Status: true;
  CategoryId: number;
  ItemPrice: number;
  ItemPriceTitle: string;
  ItemOldPrice: number;
  ItemOldPriceTitle: string;
  PriceTitle: string;
  PriceDiscountTitle: string;
  DiscountTitle: string;
  CategoryName: string;
  BranchId: number;
  BranchName: string;
  FromDate: string;
  ToDate: string;
  ItemIsNewFromDate: Date;
  ItemIsNewToDate: Date;
  PriceDiscountFromDate: Date;
  PriceDiscountToDate: Date;
  OfferValidFrom: string;
  OfferValidTo: string;
  OfferExpireOn: string;
  Discount: number;
  IsNewItem: boolean;
  IsWishListed: boolean;
  IsInStock:boolean;
  AvailableOnlyOnApp:boolean;
  IsInStockTitle :string;
  ShareLink: string;
  BoughtCount: number;
  Type: number;
  BranchShortDetails: string;
  BranchAddress: string | null;
  BranchPhone: string | null;
  BranchLatitude: number;
  BranchLongitude: number;
  IsHaveAttributes: boolean;
  ItemAttributes: ItemAttribute[];
  Attachments: ItemAttachment[] | null;
  PriceBundle: PriceBundle | null;
  ValidDateFrom: string;
}
export interface ItemAttachment {
  File: string;
  Id: number;
  ItemId: number;
  ItemName: string;
  Status: boolean;
}
export interface PriceBundle {
  DiscountPercentTitle: string;
  OldPriceTitle: string;
  PriceTitle: string;
}

export interface ItemsRes extends GoponRes {
  Data: ItemNew[];
}


export interface ItemDetailsReq {
  itemId: number;
  attributes?: ItemAttrVals[];
}
export interface ItemAttrVals {
  attributeId: string;
  attributeValues: number[];
}

export type AttributeControlTypeName =
  | 'RadioList'
  | 'DropdownList'
  | 'Checkboxes'
  | 'Datepicker'
  | 'Timepicker'
  | 'Daypicker'
  | 'Colorpicker'
  | 'MultilineTextbox'
  | 'TextBox';
export interface ItemAttribute {
  AttributeControlTypeId: number;
  AttributeControlTypeName:
    | 'RadioList'
    | 'DropdownList'
    | 'Checkboxes'
    | 'Datepicker'
    | 'Timepicker'
    | 'Daypicker'
    | 'Colorpicker'
    | 'MultilineTextbox'
    | 'TextBox';
  Id: number;
  IsRequired: boolean;
  ItemAttributeValues: ItemAttributeValues[];
  Logo?: string;
  NameTitle: string;
}
export interface ItemAttributeValues {
  Id: number;
  IsPreSelected: boolean;
  NameTitle: string;
  IsNeedPriceRefresh: boolean;
  ItemPrice: number;
  ItemPriceTitle: string;
  ItemOldPrice: number;
  ItemOldPriceTitle: string;
  Discount: number;
  DiscountTitle: string;
  Image: string;
  IsInStock: boolean;
  IsInStockTitle: string;
}
export interface ItemDetailsRes extends GoponRes {
  Item: ItemDetails;
}

export class RelatedItemsReq extends Pagable {
  itemId!: number;
}

export interface WishlistRes extends GoponRes {
  Wishlist: { ItemId: number; UserId: number };
}
